// Package Block
import { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useFormik } from 'formik';
import { TextField } from '@mui/material';
import { IconButton, InputAdornment } from '@material-ui/core';
import moment from 'moment';
import { useSelector, shallowEqual } from 'react-redux';
import { Form, Input, Col, Row, Select, notification, Button as AntButton, Checkbox, Spin } from 'antd';
import { CheckCircleOutline, SyncDisabledOutlined, HomeTwoTone, CreditCardOutlined } from '@material-ui/icons';
import { BankOutlined } from "@ant-design/icons"

// Custom components & function Block
import { PublicPayment } from './../../../Estore/_redux/Estore/basicSettingsCrud';
import { dateFormat, dateStringApplyOffSet, getCurrentUtcDateTime, getSettingKey, loadMoneyKitScript } from '../../utils';
import { PAYMENT_TYPE_SALE_ORDER, Payment_sub_type, Payment_type } from '../../constants';
import { customerAchFromPublic } from './../../../Sale/_redux/orders/ordersCrud';


function AddPaymentModal({ show, handleClose, order }) {
	const { entity: settingEntity } = useSelector((state) => ({ entity: state.basicSettings }), shallowEqual);
	let NMI_object = settingEntity?.entity?.POS?.payments ? settingEntity?.entity?.POS?.payments[Payment_type?.CREDIT_DEBIT_GATEWAY][Payment_sub_type?.NMI] : false
	const [paymentEditable, setPaymentEditable] = useState(true)
	const [paymentMethod, setPaymentMethod] = useState(NMI_object.public_key ? 3 : PAYMENT_TYPE_SALE_ORDER.ACH.value);
	const [loading, setLoading] = useState(false);
	const [successMessageModal, setSuccessMessageModal] = useState(false);
	const [loaderForInit, setLoaderForInit] = useState(false)
	const [failMessageModal, setfailMessageModal] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	const handleShowSuccessMessage = () => {
		setSuccessMessageModal(true);
	};
	const handelCloseSuccessMessage = () => {
		handleClose();
		setSuccessMessageModal(false)
		window.location.reload()
	};
	const handleShowFailMessage = () => setfailMessageModal(true);
	const handelCloseFailMessage = () => setfailMessageModal(false);
	const [checkConcent, setCheckConcent] = useState(false);
	const [checkConcetForAch, setCheckConcetForAch] = useState(false)

	const { currentState } = useSelector(
		(state) => ({
			currentState: state.basicSettings,
		}),
		shallowEqual
	);
	const { settings } = useSelector(
		(state) => ({
			settings: state.basicSettings,
		}),
		shallowEqual
	);
	const public_key = settings?.entity?.IMMUTABLE_BASIC?.public_key || settings?.entity?.IMMUTABLE_BASIC['admin-panel']?.immutable_basic?.public_key
	const { entity } = currentState;
	const paymentsobj = getSettingKey(entity, "POS", "payments");
	const timezone = getSettingKey(entity, "Basic", "timezone");
	let dateTime = getCurrentUtcDateTime(timezone);
	const todayDate = dateTime?.format(dateFormat);
	const loadScript = (src, setDataTokenizationKey) => {
		return new Promise((resolve, reject) => {
			const script = document.createElement("script");
			script.src = src;
			script.setAttribute("data-tokenization-key", setDataTokenizationKey);
			script.async = true;
			script.onload = () => resolve(script);
			script.onerror = () => reject(new Error(`Script load error for ${src}`));

			document.body.appendChild(script);
		});
	};

	useEffect(() => {
		if (show) {
			let publickey;
			try {
				publickey = paymentsobj['3']['1']?.public_key
			} catch (err) {
				publickey = "";
			}
			if (publickey) {
				loadScript(
					"https://secure.safewebservices.com/token/Collect.js",
					`${publickey}`
				)
					.then(() => {
						if (window.CollectJS) {
							window.CollectJS.configure({
								variant: "lightbox",
								callback: async ({ token }) => {
									if (token) {
										setLoading(true)
										formik.setFieldValue('payment_token', token);
										await formik.handleSubmit();
										setLoading(false)
									}
								},
							});
						}
					})
					.catch((error) => {
						handleShowFailMessage();
						handleClose();
						setLoaderForInit(false)
						console.log("public payment > erro", error)
					});
			}
		}
	}, [show]);

	const firstOnBoardCustACH = async () => {
		const _public_key= settings?.entity?.IMMUTABLE_BASIC?.public_key || settings?.entity?.IMMUTABLE_BASIC['admin-panel']?.immutable_basic?.public_key
		const res = await customerAchFromPublic(_public_key,{    "customer_id":order.customer?.id})
			
		initBankLink(res.data.entity.uuid)
	}

	const initBankLink = (grailpay_uuid = "") => {
		const grailpayUuid = grailpay_uuid || order.customer?.grailpay_uuid || formik?.values?.customer_grailpay_uuid
		formik.setFieldValue("customer_grailpay_uuid", grailpayUuid)
		const currentHost = window.location.host;

 			const isNotProd = !currentHost.includes("app.ikhub.biz") && !currentHost.includes("appp.ikhub.biz")
			const token = isNotProd ? '211|cvB97Yxl5Px5BMQm1q43bdYT8tx8INn4GeKsYXWO':"2538|Q0hh5AAG657ex3pjDAr39lfr9Rdwz4n9joS3xxOJ" ;

		setLoaderForInit(true)
		loadMoneyKitScript(
		).then(() => {
			const apiKey = token; //Add Api Key here
			const userId = grailpayUuid || ""; // Add your user ID here
			const vendorId = '9d6aa544-eb29-4497-b8fb-83d65f9be405'; // Add your vendor ID here
			window.grailpay.init({
				// containerId: 'widget-container',
				// vendorId: vendorId,
				userId: userId,
				token: apiKey,
				theme: {
					branding_name: 'Khub',
					screens: {
						finder: {
							subtitle: 'FINDER_SCREEN_SUBTITLE',
							searchPlaceholder: 'SEARCH_INPUT_PLACEHOLDER_TEXT',
						}
					}
				},
				onError: function (error) {
					console.log('GrailPay.onError', error);
				},
				onClose: function (data) {
					setLoaderForInit(false)
					console.log('GrailPay.onClose', data);
				},
				onBankConnected: data => {
					console.log('GrailPay.onBankConnected', data);

				},
				onUserCreated: data => {
					console.log('GrailPay.onUserCreated', data);

				},
				onLinkedDefaultAccount: data => {
					const { account_uuid,
						user_uuid,
						aggregator_type,
						vendor_id,
						account_status,
						account_id,
						account_number,
						provider_name,
						routing_number,
						name,
						account_type } = data
					formik.setValues({ ...formik.getFieldMeta('').value, payment_type: PAYMENT_TYPE_SALE_ORDER.ACH.value, bank_details: { account_number, routing_number, account_type, account_name: name } });
					setPaymentMethod(PAYMENT_TYPE_SALE_ORDER.ACH.value)
				},
				onLinkExit: data => {
					console.log('GrailPay.onLinkExit', data);
				},

			}).then(function (res) {
				if (res.code === 200) {
					setLoaderForInit(false)
					console.log('GrailPay Banklink Widget initialized successfully');
					grailpay_uuid && !!window?.grailpay?.open && window.grailpay.open(); // if grailpay_uuid means coming from firstOnBoardCustACH -> Link Bank Account

				}
			}).catch(function (err) {
				setLoaderForInit(false)
				notification.info({ message: "Failed initializing resource" })
				console.log(err, 'Error initializing GrailPay Banklink Widget');
			});


			//
		})
	}
	useEffect(() => {
		try {
			if (order.customer?.grailpay_uuid) {
				initBankLink()
			}
		} catch (error) {

		}
	}, [order.customer?.grailpay_uuid])
	const handleNMISetup = (event, subtype) => {
		setLoading(true)
		event.preventDefault();
		formik.setFieldValue('payment_sub_type', subtype);
		if (window.CollectJS) {
			window.CollectJS.startPaymentRequest();
			setLoading(false)
		}
		setLoading(false);
	};


	const formik = useFormik({
		initialValues: {
			sale_order_id: order?.id,
			payment_type: paymentMethod,
			payment_sub_type: 5,
			amount: order?.invoice?.remaining_amount || "",
			payment_date: todayDate,
			bank_details: {
				account_number: "",
				routing_number: "",
				account_name: "",
				account_type: ""
			},
			payment_token: "",
			customer_grailpay_uuid: order?.customer?.grailpay_uuid
		},
		onSubmit: async (values) => {

			let newValues = { ...values };
			// Remove bank_details if payment_type is 3
			if (values.payment_type === 3) {
				delete newValues.bank_details;
			}
			// Remove payment_token if payment_type is 12
			if (values.payment_type === PAYMENT_TYPE_SALE_ORDER.ACH.value) {
				delete newValues.payment_token;
			}
			setLoading(true);
			try {
				await PublicPayment(settings?.entity?.IMMUTABLE_BASIC?.public_key || settings?.entity?.IMMUTABLE_BASIC['admin-panel']?.immutable_basic?.public_key, newValues);
				setLoading(false)
				handleShowSuccessMessage()
				// handleClose();
			} catch (error) {
				console.log("public payment > erro", error)
				const errorMessage = error?.response?.data?.errors[0] || "An error occurred. Please try again.";
				setErrorMessage(errorMessage);
				handleShowFailMessage();
			} finally {
				setLoading(false)
			};
		}
	})
	// Handle Change Checkbox
	const handleChangeCheckbox = (e) => {
		setCheckConcent(e.target.checked)
	};
	const handleChangeAchCheckbox = (e) => {
		setCheckConcetForAch(e.target.checked)
	};

	useEffect(() => {
		formik.setValues({
			sale_order_id: order?.id,
			payment_type: paymentMethod,
			payment_sub_type: 5,
			amount: order?.invoice?.remaining_amount || "",
			payment_date: dateStringApplyOffSet(moment().format("YYYY-MM-DD"), timezone),
			bank_details: {
				account_number: "",
				routing_number: "",
				account_name: "",
				account_type: ""
			},
			payment_token: ""
		});
	}, [order]);

	const paymentIcons = [
		'/media/addPaymentModal/lock.png',
		'/media/addPaymentModal/fa-brands_cc-visa.png',
		'/media/addPaymentModal/logos_mastercard.png',
		'/media/addPaymentModal/cib_american-express.png',
		'/media/addPaymentModal/cib_cc-diners-club.png',
		'/media/addPaymentModal/logos_jcb.png',
		'/media/addPaymentModal/logos_maestro.png',
		'/media/addPaymentModal/discover.png',
	];
	return (
		<>
			<Modal show={show} onHide={handleClose} className='add-payament-modal' size='lg'>
				<Spin spinning={loading}>
					<Form onFinish={formik.handleSubmit} layout="vertical">
						<Modal.Header closeButton className='add-payament-modal-header'>
							<Modal.Title className='add-payment-modal-title'>Add Payment</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<Row className='d-flex justify-content-between align-items-center'>
								<Col xs={16} sm={16} md={12} lg={12}>
									<Form.Item className='invo-balance-lab' label="Invoice Balance Amount" style={{ marginBottom: "0px" }}>
										<Input
											name="amount"
											className='invo-balance-inp'
											onChange={formik.handleChange}
											value={formik.values.amount}
											disabled={paymentEditable}
											prefix={<img src="/media/addPaymentModal/$.png" alt="dollar" />}
											size='large'
											style={{ borderRadius: "10px", border: paymentEditable ? "none" : "" }}
										/>
									</Form.Item>
									{formik.values.amount > order?.invoice?.total_amount && <small style={{ color: "red" }}>Paymnet cannot exceed invoice balance.</small>}
									{(formik.values.amount === "" || formik.values.amount === 0) && !paymentEditable && <small style={{ color: "red" }}>Paymnet must be greater than 0.</small>}
								</Col>
								<Col xs={8} sm={8} md={12} lg={12}>
								<div style={{ display: 'flex', justifyContent: 'flex-end' }}><AntButton style={{ background: "#F2F2F2", textAlign: "end" }} className='t' onClick={() => setPaymentEditable(!paymentEditable)}>Edit</AntButton></div>
								</Col>
							</Row>
							<p className='invo-balance-lab mt-2'>Select A Payment Method:</p>
							<div className='d-flex justify-content-between ' >
								<Row
									className='w-100'
									gutter={{
										xs: 8,
										sm: 16,
										md: 12,
										lg: 12,
									}}>
									{NMI_object.public_key &&
										<Col sm={24} xs={24} md={6} lg={6} className='pb-2'>
											<AntButton
												type={paymentMethod === 3 ? "danger" : "default"}
												style={{
													backgroundColor: paymentMethod === 3 ? "#EA1E51" : "",
													color: paymentMethod === 3 ? "white" : ""
												}}
												size="large"
												onClick={(event) => {

													if (paymentMethod !== 3) {
														setPaymentMethod(3)
														formik.setFieldValue("payment_type", 3)
													} else {
														setPaymentMethod("")
														formik.setFieldValue("payment_type", "")
													}
												}}
												className='mr-2 custom-paymnet-option-btn'
												disabled={formik.values.amount > order?.invoice?.total_amount}
												icon={<CreditCardOutlined style={{ height: "24px", width: "24px" }} />}
											>
												Credit/Debit Card
											</AntButton>
										</Col>
									}
									<Col className='d-flex pb-2' sm={24} xs={24} md={24} lg={10} >
										<AntButton
											style={{
												backgroundColor: paymentMethod === PAYMENT_TYPE_SALE_ORDER.ACH.value ? "#EA1E51" : "",
												color: paymentMethod === PAYMENT_TYPE_SALE_ORDER.ACH.value ? "white" : "",
											}}
											size="large"
											onClick={() => {
												if (paymentMethod !== PAYMENT_TYPE_SALE_ORDER.ACH.value) {
													setPaymentMethod(PAYMENT_TYPE_SALE_ORDER.ACH.value)
													formik.setFieldValue("payment_type", PAYMENT_TYPE_SALE_ORDER.ACH.value)
												} else {
													setPaymentMethod("")
													formik.setFieldValue("payment_type", "")
												}
											}}
											disabled={formik.values.amount > order?.invoice?.total_amount}
											icon={<HomeTwoTone style={{ height: "24px", width: "24px" }} />}
											className='custom-paymnet-option-btn'
										>
											Automated Clearing House (ACH)
										</AntButton>
									</Col>
									<Col className='d-flex' sm={24} xs={24} md={24} lg={6}>
										{
											<Spin spinning={loaderForInit} >

												<AntButton
													type="primary"
													className='custom-paymnet-option-btn'
													size="large"
													// disabled={formik.values.amount > order?.invoice?.total_amount}
													id="pay-button"
													onClick={() => {
														if(!(order.customer?.grailpay_uuid || formik?.values?.customer_grailpay_uuid)){
															firstOnBoardCustACH()
														}else{
															!!window?.grailpay?.open && window.grailpay.open();
														}
														setLoaderForInit(true)
													}}
													icon={<BankOutlined style={{ height: "24px", width: "24px" }} />}
												>
													Pay by Bank
												</AntButton>
											</Spin>
										}</Col>

								</Row>
							</div>
							{paymentMethod === 3 &&
								<>
									<Row>
										<Col sm={24} xs={24} md={12} lg={12}>
											<TextField
												className='mt-8 mb-8 customize-payment-options'
												label="Secure Payment"
												InputProps={{
													readOnly: true,
													startAdornment: (
														<InputAdornment position="end">
															{paymentIcons.map((icon, index) => (
																<IconButton key={index} edge="start">
																	<img src={icon} alt={`Payment Icon ${index}`} loading="lazy" className='payment-brands' />
																</IconButton>
															))}
														</InputAdornment>
													),
													classes: {
														input: 'input-width-zero', // Apply custom class to the input element
													},
												}}
											/>
										</Col>
									</Row>
									<div className='secure-msg'>
										<div className='secure-logo'>
											<img src='/media/addPaymentModal/shield.png' alt='shield' />
										</div>
										<div className='secure-msg-desc'>
											All payment information is encrypted and sent to a secure processing gateway. We do not store or save payment details.

										</div>
									</div>
								</>
							}

							{paymentMethod === 3 && NMI_object.public_key &&
								<div style={{ display: 'flex',  gap: '8px' }}>
									<Checkbox
										checked={checkConcent}
										className='mt-6 payment-terms-and-conditions-checkbox'
										onChange={handleChangeCheckbox}
										style={{ marginTop: '2px' }}
											/><span className='mt-6'>I agree to the {" "}
										<a className='payment-terms-and-conditions'  href="https://khub.biz/terms" target="_blank">Terms & Conditions</a>
										{" "}of khub policy.</span>
								</div>
							}
							{paymentMethod === PAYMENT_TYPE_SALE_ORDER.ACH.value && (<>
								<Row
									gutter={{ xs: 8, sm: 16, md: 12, lg: 12 }}
									className='mt-5 mb-2'>
									<Col xs={24} sm={24} md={12} lg={12} style={{margin:"auto"}}>
										<Form.Item
										style={{marginBottom:"0px"}}
											label={<div style={{ padding: 0 }}>Account Number<span className='text-danger'>*</span></div>}>
											<Input
												name="bank_details.account_number"
												onChange={formik.handleChange}
												value={formik.values.bank_details.account_number}
												className='rounded'
												placeholder='Enter Account No'
												size='large'
											/>
										</Form.Item>
									</Col>
									<Col xs={24} sm={24} md={12} lg={12} style={{margin:"auto"}}>
										<Form.Item
										style={{marginBottom:"0px"}}
											label={<>Routing Number<span className='text-danger'>*</span></>}>
											<Input
												name="bank_details.routing_number"
												onChange={formik.handleChange}
												placeholder='Enter Routing No'
												value={formik.values.bank_details.routing_number}
												className='rounded'
												size='large'
											/>
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={{  md: 12, lg: 12 }}>
									<Col className='mb-5' xs={24} sm={24} md={12} lg={12} style={{margin:"auto"}}>
										<Form.Item
										style={{marginBottom:"0px"}}
											label={<>Account Name<span className='text-danger'>*</span></>}>
											<Input
												name="bank_details.account_name"
												placeholder='Enter Account Name'
												type="text"
												onChange={formik.handleChange}
												value={formik.values.bank_details.account_name}
												className='rounded'
												size='large'
											/>
										</Form.Item>
									</Col>
									<Col xs={24} sm={24} md={12} lg={12} className='pb-4 pl-0' style={{margin:"auto"}}>
										<label className='m-0'>Select Account Type<span className='text-danger'>*</span></label>
										<Select
											className='custom-select-add-payment'
											value={formik.values.bank_details.account_type} // Use 'value' instead of 'defaultValue' for better form control
											style={{ width: "100%", borderRadius: "10px" }} 
											onChange={(value) => formik.setFieldValue("bank_details.account_type", value)}
											placeholder="Select" 
											options={[
												{ value: '', label: 'Select' },
												{ value: 'checking', label: 'Checking' },
												{ value: 'savings', label: 'Savings' },
											]}
											size='large'
										/>
									</Col>
									<div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
									<Checkbox
										className='payment-terms-and-conditions-checkbox'
										checked={checkConcetForAch}
										onChange={handleChangeAchCheckbox}
										style={{ marginTop: '2px' }} 
									/>
										<span>
										By proceeding further, you acknowledge that you have read the
										<a className="payment-terms-and-conditions" href="https://khub.biz/terms" target="_blank"> Terms & Conditions</a>,
										Refund policy of the Business owner of this E-commerce Site or the Business who issued
										this Invoice, Kommerce Hub Platform, and affiliated Payment processors.<br className='mb-1'/>
										If the payment is being made via ACH, you confirm you authorize the business owner
										to perform ACH debits or credits as per this authorization that you are agreeing to,
										and also confirm that you have read the terms of GrailPay who is the affiliated payment
										processor of Kommerce Hub.<br className='mb-1'/>
										If you are paying by Credit or Debit Card, then you agree that you have received services/
										Goods to your satisfaction and agree to the terms set-forth in
										<a href="https://khub.biz/terms" className="payment-terms-and-conditions" target="_blank"> Khub.biz/terms</a> and <a className="payment-terms-and-conditions" href="https://khub.biz/privacypolicy" target="_blank">khub.biz/privacypolicy</a>
									</span>
									</div>

								</Row>
							</>)}
						</Modal.Body>
						<Modal.Footer
							className='add-payment-modal-footer'
							style={{ padding: "1rem", justifyContent: "space-between" }}
						>
							<div className='powered-by-message'>
								{paymentMethod === PAYMENT_TYPE_SALE_ORDER.ACH.value && (<><img src='/media/addPaymentModal/shield.png' alt='shield' /> <span>Powered By <span className='comapny-name'>Kommerce Hub</span></span></>)}
							</div>
							<div>
								<Button variant="secondary" className='mr-2' onClick={handleClose}> Cancel </Button>
								{paymentMethod === 3 && (
									<>
										<Button
											className='credit-debit-btns'
											disabled={!checkConcent}
											onClick={(event) => handleNMISetup(event, 5)}
											loading={loading}
										>
											Add Payment & Pay
										</Button>
									</>
								)}
								{paymentMethod === PAYMENT_TYPE_SALE_ORDER.ACH.value &&
									<Button
										variant="primary"
										htmlType="submit"
										className='credit-debit-btns'
										style={{ width: "85px" }}
										disabled={!checkConcetForAch}
										onClick={() => {
											if (!formik.values.bank_details.account_number ||
												!formik.values.bank_details.account_name ||
												!formik.values.bank_details.account_type ||
												!formik.values.bank_details.routing_number) {
												notification.error({ message: "Please fill all the required fields." })
												return
											}
											if (formik.values.amount > order?.invoice?.total_amount || !checkConcetForAch) {
												notification.error({ message: "Please agree to the terms by checking the box in order to proceed." })
												return
											}

											formik.handleSubmit()
										}}>
										Pay
									</Button>
								}
							</div>
						</Modal.Footer>
					</Form>
				</Spin>
			</Modal>
			<Modal show={successMessageModal} onHide={handelCloseSuccessMessage}>
				<Modal.Body >
					<div style={{ display: "flex", justifyContent: "center", textAlign: "center", flexDirection: "column" }}>
						<div><CheckCircleOutline style={{ fontSize: "60px", marginBottom: "5px", color: "green" }} /></div>
						<h4>Payment Successful!</h4>
						<p>Your payment has been processed successfully</p>
						<Button onClick={() => {
							handelCloseSuccessMessage()
						}}>Done</Button>
					</div>
				</Modal.Body>
			</Modal>
			<Modal show={failMessageModal} onHide={handelCloseFailMessage}>
				<Modal.Body >
					<div style={{ display: "flex", justifyContent: "center", textAlign: "center", flexDirection: "column" }}>
						<div><SyncDisabledOutlined style={{ fontSize: "60px", marginBottom: "5px", color: "red" }} /></div>
						<h4>Payment Failed!</h4>
						<p>{errorMessage || "Unfortunately you payment was rejected"}</p>
						<Button onClick={() => {
							handelCloseFailMessage()
							window.location.reload()
						}}>Retry</Button>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
}

export default AddPaymentModal;
